import AgInvoiceApply from '@/pages/invoiceManage/agInvoiceApply'
import InvoiceOrderDetail from '@/pages/orderManage/agOrderList/OrderDetail'

export default [
  {
    path: '/agInvoiceApply',
    name: 'AgInvoiceApply',
    component: AgInvoiceApply,
    meta: { name: '发票申请' }
  },
  {
    path: '/agInvoiceApply/invoiceOrderDetail/:orderId',
    name: 'InvoiceOrderDetail',
    component: InvoiceOrderDetail,
    props: true,
    meta: { name: '订单详情' }
  }
]



// WEBPACK FOOTER //
// ./src/router/invoiceManage/agInvoiceApply.js